// extracted by mini-css-extract-plugin
export default {"root":"kWN2uu","title":"n0ipiM"};